<!-- Respaldo por si el navegador no redirige solo -->
<section class="text-center">
  <p>Te estamos llevando a nuestro aviso de privacidad&hellip;</p>
  <p>Si no avanza, <a [href]="privacyNoticeUrl">da clic aquí</a>.</p>
</section>
